import { render, staticRenderFns } from "./ReorderWidgetGroupDialog.vue?vue&type=template&id=3fa5559f&scoped=true"
import script from "./ReorderWidgetGroupDialog.vue?vue&type=script&lang=js"
export * from "./ReorderWidgetGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./ReorderWidgetGroupDialog.vue?vue&type=style&index=0&id=3fa5559f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa5559f",
  null
  
)

export default component.exports